module.exports = __webpack_public_path__ + "img/28.3f9b47e5.jpg";